import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment'
import { OBJSORT, ARRAYSORT } from '@/utils'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    settings: null,
    locationsBox: true,
    home_data: [],
    prjFilters: {
      date_range: null,
      id_oceano: null,
      type: [],
      status: null
    },
    mapFilters: {
      'location': null,
      'nationality': null,
      'type': ['drifter', 'float', 'glider'],
      'date_from': moment().subtract(3, 'days').format('YYYY-MM-DD'),
      'date_to': moment().format('YYYY-MM-DD'),
      'project': null,
      'id': null,
      'wmo': null,
      'imei': null,
      'instrument': null,
      'deployment': null
    },
    rengeMarkers: {},
    projects: [],
    project: {},
    people: [],
    partners: [],
    instruments: [],
    instrumentsFilter: [],
    locations: [],
    nameProjects: [],
    years: [],
    boe: [],
    publications: [],
    pubFilters: {
      year: null,
      author: null,
      title: null,
      type: null
    },
    boeSearch: [],
    boeList: [],
    mapGeojson: {
      'type': 'FeatureCollection',
      'features': []
    },
    markers: {
      'type': 'FeatureCollection',
      'features': []
    },
    home_markers: {
      'type': 'FeatureCollection',
      'features': []
    },
    trajectories: {
      'type': 'FeatureCollection',
      'features': []
    },
    loadedBoe: false,
    loadedTable: false,
    loadedMarkers: false
  },
  mutations: {
    SET_SETTINGS: (state, { list }) => {
      state.settings = list
    },
    SET_HOME_DATA: (state, { list }) => {
      state.home_data = list
    },
    SET_HOME_MARKERS: (state, { list }) => {
      if (list.features !== null) {
        state.home_markers = list
      }
    },
    SET_PROJECT_LIST: (state, { list }) => {
      state.projects = list
    },
    SET_PROJECT: (state, { prj }) => {
      state.project = prj
    },
    SET_FILTER_PROJECT_LIST: (state, { list }) => {
      state.nameProjects = list
    },
    SET_PEOPLE_LIST: (state, { list }) => {
      state.people = list
    },
    SET_PARTNERS_LIST: (state, { list }) => {
      state.partners = list
    },
    SET_INSTRUMENTS_LIST: (state, { list }) => {
      state.instruments = list
    },
    SET_INSTRUMENTS_FILTER_LIST: (state, { list }) => {
      state.instrumentsFilter = list
    },
    SET_YEARS_LIST: (state, { list }) => {
      state.years = list
    },
    SET_LOCATIONS_LIST: (state, { list }) => {
      state.locations = list
    },
    SET_PUBLICATIONS_LIST: (state, { list }) => {
      state.publications = list
    },
    SET_PROJECT_YEAR_LIST: (state, year) => {
      state.projects = state.projects.filter(project => project.date_range.includes(year))
    },
    SET_PROJECT_LOCATION_LIST: (state, location) => {
      state.projects = state.projects.filter(project => project.location.name === location)
    },
    SET_PROJECT_TYPE_LIST: (state, type) => {
      state.projects = state.projects.filter(project => project.type.find(t => type.includes(t)))
    },
    SET_RANGE_MARKERS: (state, { list }) => {
      state.rengeMarkers = list
    },
    SET_MARKERS_LIST: (state, { list }) => {
      state.markers = list
    },
    SET_MAP_GEOJSON: (state, { day }) => {
      if (state.rengeMarkers[day] && state.rengeMarkers[day].hasOwnProperty('features')) {
        state.mapGeojson = state.rengeMarkers[day]
      } else {
        // is not geojson valid
        state.mapGeojson = {
          'type': 'FeatureCollection',
          'features': []
        }
      }
    },
    SET_BOE: (state, { list, type }) => {
      if (type === 'table') {
        state.boe = list
      } else if (type === 'count') {
        state.boeSearch = list
      } else if (type === 'list') {
        state.boeList = list
        state.boeSearch = list
      }
    },
    SET_PRJ_FILTERS: (state, {dateRange, idOceano, status, type}) => {
      dateRange = (dateRange === 'All') ? null : dateRange
      state.prjFilters.date_range = dateRange || null
      state.prjFilters.id_oceano = idOceano || null
      state.prjFilters.status = status || null
      state.prjFilters.type = type.length ? type : null
    },
    SET_PUB_FILTERS: (state, {type, year, author, title}) => {
      type = (type === 'All') ? null : type
      year = (year === 'All') ? null : year
      state.pubFilters.year = year || null
      state.pubFilters.type = type || null
      state.pubFilters.author = author || null
      state.pubFilters.title = title || null
    },
    SET_MAP_FILTERS: (state, {type, location, nationality, dateFrom, dateTo, project, instrument, deployment}) => {
      state.mapFilters.type = type || ['drifter', 'float', 'glider']
      state.mapFilters.location = location || null
      state.mapFilters.nationality = nationality || null
      state.mapFilters.date_from = dateFrom || ''
      state.mapFilters.date_to = dateTo || null
      state.mapFilters.project = project || null
      state.mapFilters.instrument = instrument || null
      state.mapFilters.deployment = deployment || null
    },
    RESET_MAP_FILTERS: (state) => {
      state.mapFilters = {
        'location': null,
        'nationality': null,
        'type': ['drifter', 'float', 'glider'],
        'date_from': '',
        'date_to': '',
        'project': null,
        'id': null,
        'wmo': null,
        'imei': null,
        'instrument': null,
        'deployment': null
      }
    },
    SET_LOCATION_BOX: (state, status) => {
      state.locationsBox = status
    },
    SET_TRAJECTORY: (state, { list }) => {
      if (list.features.length) {
        state.trajectories.features.push(list.features[0])
      }
    },
    UNSET_TRAJECTORY: (state, id) => {
      state.trajectories.features = state.trajectories.features.filter(boa => boa.properties.id.toString() !== id.toString())
    },
    CLEAR_TRAJECTORIES: (state) => {
      state.trajectories.features = []
    },
    SET_LOADED_BOE: (state, {loaded, type}) => {
      if (type === 'table') {
        state.loadedTable = loaded
      } else {
        state.loadedBoe = loaded
      }
    },
    SET_LOADED_MARKERS: (state, value) => {
      state.loadedMarkers = value
    }
  },
  actions: {
    LOAD_SETTINGS: function ({ commit }) {
      axios.get('settings').then((response) => {
        commit('SET_SETTINGS', { list: response.data.result })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_HOME_MARKERS: function ({ commit }) {
      axios.get('markers?status=A').then((response) => {
        commit('SET_HOME_MARKERS', { list: response.data })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_HOME_DATA: function ({ commit }) {
      axios.get('home-data').then((response) => {
        commit('SET_HOME_DATA', { list: response.data })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_PROJECT_LIST: function ({ commit }) {
      axios.get('projects').then((response) => {
        commit('SET_PROJECT_LIST', { list: response.data.result })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_PUBLICATIONS_LIST: function ({ commit }) {
      axios.get('publications').then((response) => {
        commit('SET_PUBLICATIONS_LIST', { list: response.data.result })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_PROJECT: function ({ commit }, id) {
      return axios.get(`projects/${id}`).then((response) => {
        commit('SET_PROJECT', { prj: response.data.result[0] })
        return response
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_FILTER_PROJECT_LIST: function ({ commit }, filters) {
      // console.log('filters', filters)
      axios.get(`projectslist?${filters}`).then((response) => {
        commit('SET_FILTER_PROJECT_LIST', { list: response.data.result })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_PEOPLE_LIST: function ({ commit }) {
      axios.get('people').then((response) => {
        commit('SET_PEOPLE_LIST', { list: response.data.result })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_PARTNERS_LIST: function ({ commit }) {
      axios.get('partners').then((response) => {
        commit('SET_PARTNERS_LIST', { list: response.data.result })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_INSTRUMENTS_LIST: function ({ commit }, type) {
      axios.get(`instruments?type=${type}`).then((response) => {
        commit('SET_INSTRUMENTS_LIST', { list: response.data })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_INSTRUMENTS_FILTER_LIST: function ({ commit }, filters) {
      return axios.get(`typeList?${filters}`).then((response) => {
        commit('SET_INSTRUMENTS_FILTER_LIST', { list: response.data.result })
        return response
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_YEARS_LIST: function ({ commit }) {
      axios.get('years').then((response) => {
        commit('SET_YEARS_LIST', { list: response.data.result })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_LOCATIONS_LIST: function ({ commit }) {
      axios.get('locations').then((response) => {
        commit('SET_LOCATIONS_LIST', { list: response.data.result })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_PROJECT_YEAR_LIST: function ({ commit }, year) {
      commit('SET_PROJECT_YEAR_LIST', year)
    },
    LOAD_PROJECT_LOCATION_LIST: function ({ commit }, location) {
      commit('SET_PROJECT_LOCATION_LIST', location)
    },
    LOAD_PROJECT_TYPE_LIST: function ({ commit }, location) {
      commit('SET_PROJECT_TYPE_LIST', location)
    },
    LOAD_BOE_LIST: function ({ commit }, [filters, value]) {
      commit('SET_LOADED_BOE', {loaded: false, type: value})
      axios.get(`boe?${filters}`).then((response) => {
        commit('SET_BOE', { list: response.data, type: value })
        commit('SET_LOADED_BOE', {loaded: true, type: value})
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_RANGE_MARKERS: function ({ commit }, filters) {
      axios.get(`time-markers?${filters}`).then((response) => {
        commit('SET_MARKERS_LIST', { list: response.data })
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_MARKERS: function ({ commit }, filters) {
      commit('SET_LOADED_MARKERS', false)
      axios.get(`time-markers-def?${filters}`).then((response) => {
        commit('SET_MARKERS_LIST', { list: response.data })
        commit('SET_LOADED_MARKERS', true)
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_TRAJECTORY: function ({ commit }, filters) {
      return axios.get(`trajectory?${filters}`).then((response) => {
        commit('SET_TRAJECTORY', { list: response.data })
        return response
      }, (err) => {
        console.log(err)
      })
    }
  },
  getters: {
    markers: state => state.markers,

    boe: state => state.boe,

    instrumentsFilter: state => state.instrumentsFilter,

    trajectory: state => state.trajectory,

    selectLocations: state => state.locations,

    publicationsFilters: state => state.publications,

    publications: state => {
      // type, year, author, title, type
      return state.publications.filter((item) => {
        return (state.pubFilters.year === null)
          ? true
          : item.year === state.pubFilters.year
      }).filter((item) => {
        return (state.pubFilters.type === null)
          ? true
          : item.tipo === state.pubFilters.type
      }).filter((item) => {
        return (state.pubFilters.author === null)
          ? true
          : (item.autori === null)
            ? false
            : item.autori.toLowerCase().includes(state.pubFilters.author.toLowerCase())
      }).filter((item) => {
        return (state.pubFilters.title === null)
          ? true
          : (item.titolo === null)
            ? false
            : item.titolo.toLowerCase().includes(state.pubFilters.title.toLowerCase())
      })
    },

    selectProjects: state => {
      state.nameProjects = state.nameProjects ? state.nameProjects : []
      return state.nameProjects
    },

    nationality: state => {
      const selectBoe = []
      state.boeList.map(function (x) {
        if (x.country_www !== null) {
          selectBoe.push(x.country_www.toString())
        }
      })
      return [...new Set(selectBoe)].sort(ARRAYSORT)
    },

    wmo: state => {
      const selectBoe = []
      state.boeList.map(function (x) {
        if (x.wmo_nolink !== null) {
          selectBoe.push(x.wmo_nolink.toString())
        }
      })
      return selectBoe.sort(OBJSORT)
    },

    idBoe: state => {
      const selectBoe = []
      state.boeList.map(function (x) {
        if (x.id_boa !== null) {
          selectBoe.push(x.id_boa.toString())
        }
      })
      return selectBoe.sort(OBJSORT)
    },

    imei: state => {
      const selectBoe = []
      state.boeList.map(function (x) {
        if (x.imei !== null) {
          selectBoe.push(x.imei.toString())
        }
      })
      return selectBoe.sort(OBJSORT)
    },

    project: state => {
      state.project.intro = state.project.html_description
        ? state.project.html_description[0].descrizione
        : ''

      state.project.scientifics = state.project.html_description
        ? state.project.html_description.filter(h => h.ordine !== 1)
        : []

      if (state.project.charts) {
        state.project.charts.map((chart, index) => {
          chart.is_active = index ? 0 : 1
        })
      }
      return state.project
    },

    projects: state => {
      return state.projects.filter((item) => {
        return (state.prjFilters.date_range === null)
          ? true
          : item.date_range.includes(state.prjFilters.date_range)
      }).filter((item) => {
        return (state.prjFilters.status === null)
          ? true
          : item.status === state.prjFilters.status
      }).filter((item) => {
        return (state.prjFilters.id_oceano === null)
          ? true
          : item.location.some(l => l.id === state.prjFilters.id_oceano)
      }).filter((item) => {
        return (state.prjFilters.type === null)
          ? true
          : item.type.some(a => state.prjFilters.type.some(m => a === m))
      })
    },

    boeCount: state => state.boe.length,

    boeSearchCount: state => state.boeSearch.length,

    allmarkers: state => state.markers,

    instrument: (state, getters) => (id) => {
      return state.instruments.filter(instrument => instrument.id_instrument === id)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js